import Svg from '@app/components/svg';

const ChartsWithSparkles = Svg(
  () => (
    <>
      <g filter="url(#filter0_d_1_3944)">
        <path
          d="M109.841 29H12.5854C10.4775 29 8.76874 30.7088 8.76874 32.8167V102.489C8.76874 104.597 10.4775 106.306 12.5854 106.306H109.841C111.949 106.306 113.658 104.597 113.658 102.489V32.8167C113.658 30.7088 111.949 29 109.841 29Z"
          fill="#F2F6F8"
        />
      </g>
      <path
        d="M35.2243 54.8334H21.691V89.6778H35.2243V54.8334Z"
        fill="#E6EBED"
      />
      <path
        d="M100.741 54.8334H87.2076V89.6778H100.741V54.8334Z"
        fill="#E6EBED"
      />
      <path
        d="M67.9632 67.7222H54.4299V89.6778H67.9632V67.7222Z"
        fill="#E6EBED"
      />
      <path
        d="M51.591 72.6778H38.0577V89.6722H51.591V72.6778Z"
        fill="#E6EBED"
      />
      <path
        d="M84.3521 45.9889H70.8188V89.6722H84.3521V45.9889Z"
        fill="#E6EBED"
      />
      <g filter="url(#filter1_d_1_3944)">
        <path
          d="M236.208 29H138.952C136.844 29 135.135 30.7088 135.135 32.8167V102.489C135.135 104.597 136.844 106.306 138.952 106.306H236.208C238.316 106.306 240.024 104.597 240.024 102.489V32.8167C240.024 30.7088 238.316 29 236.208 29Z"
          fill="#F2F6F8"
        />
      </g>
      <path
        d="M178.124 54.8334H164.591V89.6778H178.124V54.8334Z"
        fill="#E6EBED"
      />
      <path
        d="M211.191 54.8334H197.658V89.6778H211.191V54.8334Z"
        fill="#E6EBED"
      />
      <path
        d="M227.724 67.7222H214.191V89.6778H227.724V67.7222Z"
        fill="#E6EBED"
      />
      <path
        d="M161.591 72.6778H148.058V89.6722H161.591V72.6778Z"
        fill="#E6EBED"
      />
      <path
        d="M194.658 45.9889H181.124V89.6722H194.658V45.9889Z"
        fill="#E6EBED"
      />
      <g filter="url(#filter2_d_1_3944)">
        <path
          d="M162.085 64H85.5854C83.4775 64 81.7687 65.7088 81.7687 67.8167V144.317C81.7687 146.425 83.4775 148.133 85.5854 148.133H162.085C164.193 148.133 165.902 146.425 165.902 144.317V67.8167C165.902 65.7088 164.193 64 162.085 64Z"
          fill="#F2F6F8"
        />
      </g>
      <path
        d="M123.835 106.067H153.23C153.23 100.711 151.791 95.6946 149.291 91.3724L123.841 106.067H123.835Z"
        fill="white"
      />
      <path
        d="M149.285 91.3724C146.702 86.9113 142.985 83.1946 138.53 80.6168L123.835 106.067L149.285 91.3724Z"
        fill="white"
      />
      <path
        d="M123.835 76.6724C118.48 76.6724 113.463 78.1113 109.141 80.6113L123.835 106.061V76.6668V76.6724Z"
        fill="white"
      />
      <path
        d="M123.835 106.067L138.53 131.517C142.991 128.933 146.708 125.217 149.285 120.761L123.835 106.067Z"
        fill="#E6EBED"
      />
      <path
        d="M123.835 106.067V135.461C129.191 135.461 134.208 134.022 138.53 131.522L123.835 106.072V106.067Z"
        fill="#E6EBED"
      />
      <path
        d="M123.835 106.067L149.285 120.761C151.785 116.439 153.224 111.422 153.224 106.067H123.83H123.835Z"
        fill="#E6EBED"
      />
      <path
        d="M109.135 131.522C113.458 134.022 118.474 135.461 123.83 135.461V106.067L109.135 131.517V131.522Z"
        fill="#E6EBED"
      />
      <path
        d="M123.835 106.067L98.3855 120.761C100.969 125.222 104.685 128.939 109.141 131.517L123.835 106.067Z"
        fill="#E6EBED"
      />
      <path
        d="M123.835 106.067L98.3855 91.3724C95.8855 95.6946 94.4466 100.711 94.4466 106.067H123.841H123.835Z"
        fill="#D6DFE2"
      />
      <path
        d="M123.835 106.067L109.141 80.6168C104.68 83.2002 100.963 86.9168 98.3855 91.3724L123.835 106.067Z"
        fill="#D6DFE2"
      />
      <path
        d="M94.441 106.067C94.441 111.422 95.8799 116.439 98.3799 120.761L123.83 106.067H94.4354H94.441Z"
        fill="#D6DFE2"
      />
      <path
        d="M123.835 106.067L138.53 80.6168C134.208 78.1168 129.191 76.6779 123.835 76.6779V106.072V106.067Z"
        fill="white"
      />
      <path
        d="M123.835 120.428C131.767 120.428 138.197 113.998 138.197 106.067C138.197 98.1353 131.767 91.7056 123.835 91.7056C115.904 91.7056 109.474 98.1353 109.474 106.067C109.474 113.998 115.904 120.428 123.835 120.428Z"
        fill="#F2F6F8"
      />
      <path
        d="M247.618 24.3841L246.161 25.8416L248.547 28.2273L250.004 26.7698L247.618 24.3841Z"
        fill="#99B0B7"
      />
      <path
        d="M253.462 30.227L252.004 31.6845L254.39 34.0703L255.847 32.6128L253.462 30.227Z"
        fill="#99B0B7"
      />
      <path
        d="M254.384 24.382L251.997 26.7692L253.454 28.2258L255.841 25.8386L254.384 24.382Z"
        fill="#99B0B7"
      />
      <path
        d="M248.538 30.2286L246.151 32.6158L247.607 34.0724L249.995 31.6851L248.538 30.2286Z"
        fill="#99B0B7"
      />
      <path
        d="M63.6185 160.384L62.161 161.842L64.5468 164.227L66.0042 162.77L63.6185 160.384Z"
        fill="#99B0B7"
      />
      <path
        d="M69.4616 166.227L68.0041 167.684L70.3899 170.07L71.8473 168.613L69.4616 166.227Z"
        fill="#99B0B7"
      />
      <path
        d="M70.3844 160.382L67.9972 162.769L69.4538 164.226L71.841 161.839L70.3844 160.382Z"
        fill="#99B0B7"
      />
      <path
        d="M64.5379 166.229L62.1507 168.616L63.6073 170.072L65.9945 167.685L64.5379 166.229Z"
        fill="#99B0B7"
      />
      <path
        d="M251.866 7.33016L251.865 9.40253L253.937 9.4019L253.938 7.32953L251.866 7.33016Z"
        fill="#99B0B7"
      />
      <path
        d="M247.102 12.1243L247.101 14.1967L249.174 14.1964L249.175 12.124L247.102 12.1243Z"
        fill="#99B0B7"
      />
      <path
        d="M247.119 2.54427L247.118 4.61664L249.19 4.61637L249.191 2.54401L247.119 2.54427Z"
        fill="#99B0B7"
      />
      <path
        d="M242.326 7.34328L242.325 9.41565L244.398 9.41538L244.399 7.34302L242.326 7.34328Z"
        fill="#99B0B7"
      />
      <path
        d="M251.366 10.131L249.9 11.5969L251.365 13.0618L252.831 11.596L251.366 10.131Z"
        fill="#99B0B7"
      />
      <path
        d="M244.617 10.1498L243.151 11.6157L244.616 13.0806L246.081 11.6148L244.617 10.1498Z"
        fill="#99B0B7"
      />
      <path
        d="M251.384 3.38189L249.919 4.84772L251.384 6.31266L252.849 4.84683L251.384 3.38189Z"
        fill="#99B0B7"
      />
      <path
        d="M244.619 3.38384L243.153 4.84967L244.618 6.31461L246.083 4.84878L244.619 3.38384Z"
        fill="#99B0B7"
      />
      <path
        d="M216.172 15.1947L216.172 17.2546L219.504 17.2536L217.151 19.6073L218.607 21.0638L220.961 18.7101L220.96 22.0428L223.02 22.0422L223.021 18.7095L225.373 21.0618L226.831 19.6043L224.478 17.2521L227.811 17.2511L227.812 15.1911L224.479 15.1921L226.833 12.8384L225.376 11.3819L223.022 13.7356L223.023 10.4029L220.963 10.4035L220.962 13.7362L218.61 11.3839L217.153 12.8414L219.505 15.1936L216.172 15.1947ZM219.538 15.2104L220.971 13.7781L222.997 13.7775L224.429 15.2089L224.428 17.2353L222.996 18.6677L220.969 18.6683L219.538 17.2368L219.538 15.2104Z"
        fill="#99B0B7"
      />
      <path
        d="M90.374 164.14L88.9082 165.605L90.3731 167.07L91.8389 165.605L90.374 164.14Z"
        fill="#99B0B7"
      />
      <path
        d="M83.6165 164.15L82.1507 165.616L83.6157 167.081L85.0815 165.615L83.6165 164.15Z"
        fill="#99B0B7"
      />
      <path
        d="M90.3844 157.382L88.9186 158.848L90.3835 160.313L91.8493 158.847L90.3844 157.382Z"
        fill="#99B0B7"
      />
      <path
        d="M83.6185 157.384L82.1527 158.85L83.6177 160.315L85.0835 158.849L83.6185 157.384Z"
        fill="#99B0B7"
      />
      <path
        d="M68.6005 135.036L68.5995 138.411L70.66 138.41L70.661 135.035L68.6005 135.036Z"
        fill="#99B0B7"
      />
      <path
        d="M68.5913 143.314L68.5903 146.689L70.6508 146.688L70.6518 143.313L68.5913 143.314Z"
        fill="#99B0B7"
      />
      <path
        d="M72.0943 139.834L72.0937 141.895L75.4687 141.894L75.4693 139.833L72.0943 139.834Z"
        fill="#99B0B7"
      />
      <path
        d="M63.816 139.83L63.8154 141.891L67.1904 141.89L67.191 139.829L63.816 139.83Z"
        fill="#99B0B7"
      />
      <defs>
        <filter
          id="filter0_d_1_3944"
          x="0.557815"
          y="20.7891"
          width="121.311"
          height="93.7274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.10546" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_3944"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_3944"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1_3944"
          x="126.925"
          y="20.7891"
          width="121.311"
          height="93.7274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.10546" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_3944"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_3944"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_1_3944"
          x="73.5578"
          y="55.7891"
          width="100.555"
          height="100.555"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.10546" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_3944"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_3944"
            result="shape"
          />
        </filter>
      </defs>
    </>
  ),
  {
    fill: 'none',
    viewBox: '0 0 260 174',
  },
);

ChartsWithSparkles.displayName = 'ChartsWithSparkles';

export { ChartsWithSparkles };
